document.addEventListener('DOMContentLoaded', () => {
    // --- VARIABLES ---
    let lastScrollY = window.scrollY;
    let scrollStartY = 0;
    let prevMode = null;

    // --- DOM ELEMENTS ---
    const header = document.querySelector('.template-header');
    const detailsBar = document.getElementById('details-bar');
    const barBlur = document.getElementById('details-bar-blur');
    const viewDemoBtn = document.getElementById('view-demo');
    const modeFull = document.getElementById('mode-full');
    const viewDemoDiv = document.querySelector('div[data-demo-store-target="shimmer"]');
    const closeDemoBtn = document.querySelector('.close-demo');
    const tryTheme = document.querySelector('.try-theme');
    const fullScreenBtn = document.querySelector('button[data-active="full-screen"]');
    const demoContainer = document.getElementById('demo-container');
    const iframeContainer = document.getElementById('demo-iframe-container');
    const modeSwitcher = document.getElementById('mode-switcher');
    const buttons = document.querySelectorAll('#mode-switcher .switch-button button');
    const bodyTemplate = document.querySelector('body.page-temlates');

    // --- SCROLL HANDLER ---
    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        const isDesktop = window.innerWidth >= 1024;
        const detailsRect = detailsBar.getBoundingClientRect();
        const detailsActive = detailsRect.top <= 76;

        if (isDesktop) {
            if (detailsActive) {
                detailsBar.classList.add('active');

                if (!header.classList.contains('active-scroll')) {
                    scrollStartY = scrollY;
                }

                header.classList.add('active-scroll');

                let scrollDelta = scrollY - scrollStartY;
                if (scrollDelta < 0) scrollDelta = 0;
                if (scrollDelta > 120) scrollDelta = 120;
                header.style.setProperty('--scroll-top', scrollDelta);
            } else {
                detailsBar.classList.remove('active');
                header.classList.remove('active-scroll');
                scrollStartY = 0;
                header.style.setProperty('--scroll-top', 0);
            }

            lastScrollY = scrollY <= 0 ? 0 : scrollY;
        }
    });

    function setActive(buttonToActivate, ignoreFullscreen = true) {
        const iframe = iframeContainer.querySelector('iframe');
        const isDemoActive = iframeContainer.classList.contains('demo-active');

        if (!isDemoActive || !document.startViewTransition) {
            applyMode(buttonToActivate, ignoreFullscreen);
            return;
        }
        iframe.style.viewTransitionName = 'demo-iframe';

        document.startViewTransition(() => {
            applyMode(buttonToActivate, ignoreFullscreen);
        });

        setTimeout(() => {
            iframe.style.removeProperty('view-transition-name');
        }, 300);
    }

    function applyMode(buttonToActivate, ignoreFullscreen) {
        const isFullscreen = Array.from(buttons).find((btn) => btn.getAttribute('data-active') === 'full-screen');

        if (buttonToActivate.getAttribute('data-active') !== 'full-screen' && isFullscreen) {
            isFullscreen.classList.remove('active');
            isFullscreen.setAttribute('aria-pressed', 'false');
        }

        buttons.forEach((button) => {
            const isActive = button === buttonToActivate;

            if (ignoreFullscreen && button.getAttribute('data-active') === 'full-screen') {
                return;
            }

            button.classList.toggle('active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

            if (isActive) {
                iframeContainer.classList.remove('desktop-mode', 'mobile-mode', 'fullscreen-mode');
                iframeContainer.classList.add(button.getAttribute('data-active'));

                demoContainer.classList.remove('desktop-mode', 'mobile-mode', 'fullscreen-mode');
                demoContainer.classList.add(button.getAttribute('data-active'));
            }
        });
    }

    function updateActiveMode() {
        const isDesktop = window.innerWidth >= 1024;
        const activeButton = Array.from(buttons).find(
            (btn) =>
                (isDesktop && btn.getAttribute('data-active') === 'desktop-mode') ||
                (!isDesktop && btn.getAttribute('data-active') === 'mobile-mode'),
        );
        if (activeButton) setActive(activeButton);
    }

    updateActiveMode();

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            setActive(button);
        });
    });

    // --- OPEN DEMO ---
    // viewDemoBtn?.addEventListener('click', () => {
    //     closeDemoBtn?.classList.remove('opacity-0');
    //     tryTheme?.classList.remove('opacity-0');
    //     fullScreenBtn?.classList.remove('hidden');
    //     iframeContainer?.classList.add('demo-active');
    //     barBlur?.classList.add('opacity-0');

    //     setTimeout(() => {
    //         detailsBar?.classList.add('demo-active');
    //     }, 500);
    // });
    const popup = document.getElementById('demo-alert-popup');
    const closePopupBtn = document.getElementById('close-popup-btn');
    const openDemo = () => {
        const iframe = iframeContainer?.querySelector('iframe');
        const iframeSrc = iframe?.getAttribute('src');
        if (!iframeSrc || iframeSrc.trim() === '' || iframeSrc === 'about:blank') {
            if (popup) popup.style.display = 'flex';
            return;
        }
        modeFull?.classList.remove('hidden');
        modeFull?.classList.add('flex');
        closeDemoBtn?.classList.remove('opacity-0');
        tryTheme?.classList.remove('opacity-0');
        fullScreenBtn?.classList.remove('hidden');
        iframeContainer?.classList.add('demo-active');
        barBlur?.classList.add('opacity-0');
        fullScreenBtn?.click();
        setTimeout(() => {
            detailsBar?.classList.add('demo-active');
        }, 500);
    };
    closePopupBtn?.addEventListener('click', () => {
        popup.style.display = 'none';
    });

    window.addEventListener('click', (e) => {
        if (e.target === popup) {
            popup.style.display = 'none';
        }
    });
    viewDemoBtn?.addEventListener('click', openDemo);
    viewDemoDiv?.addEventListener('click', openDemo);

    // --- FULLSCREEN TOGGLE ---
    fullScreenBtn?.addEventListener('click', () => {
        const isFullscreen = iframeContainer.classList.contains('fullscreen-mode');

        if (!isFullscreen) {
            const activeModeBtn = Array.from(buttons)
                .filter((btn) => btn.getAttribute('data-active') !== 'full-screen')
                .find((btn) => btn.classList.contains('active'));
            prevMode = activeModeBtn?.getAttribute('data-active');
            iframeContainer.classList.add('fullscreen-mode');
            modeSwitcher.classList.add('fix-fullscreen');
            bodyTemplate.style.overflow = 'hidden';
            bodyTemplate.classList.add('demo-active');
            fullScreenBtn.classList.add('close-full', 'active');
        } else {
            iframeContainer.classList.remove('fullscreen-mode');
            modeSwitcher.classList.remove('fix-fullscreen');
            bodyTemplate.style.overflow = '';
            bodyTemplate.classList.remove('demo-active');
            fullScreenBtn.classList.remove('close-full', 'active');

            if (iframeContainer.classList.contains('desktop-mode')) {
                const prevButton = Array.from(buttons).find((btn) => btn.getAttribute('data-active') === 'desktop-mode');
                if (prevButton) {
                    setActive(prevButton, true);
                }
            } else if (iframeContainer.classList.contains('mobile-mode')) {
                const prevButton = Array.from(buttons).find((btn) => btn.getAttribute('data-active') === 'mobile-mode');
                if (prevButton) {
                    setActive(prevButton, true);
                }
            }
        }
    });
    closeDemoBtn?.addEventListener('click', () => {
        closeDemoBtn.classList.add('opacity-0');
        tryTheme?.classList.add('opacity-0');
        fullScreenBtn?.classList.add('hidden');
        detailsBar?.classList.remove('demo-active');
        iframeContainer.classList.remove('demo-active', 'fullscreen-mode');
        demoContainer.classList.remove('demo-active', 'fullscreen-mode');
        modeSwitcher.classList.remove('fix-fullscreen');
        bodyTemplate.style.overflow = '';
        bodyTemplate.classList.remove('demo-active');
        barBlur?.classList.remove('opacity-0');
        modeFull?.classList.add('hidden');
        modeFull?.classList.remove('flex');

        if (window.innerWidth < 1024) {
            const mobileBtn = Array.from(buttons).find((btn) => btn.getAttribute('data-active') === 'mobile-mode');
            if (mobileBtn) {
                setActive(mobileBtn, true, true);
            }
        } else {
            const desktopBtn = Array.from(buttons).find((btn) => btn.getAttribute('data-active') === 'desktop-mode');
            if (desktopBtn) {
                setActive(desktopBtn, true, true);
            }
        }
    });
});

const hoverZone = document.querySelector('[data-controller="monorail-click-tracking"]');
const cursorEl = document.querySelector('[data-demo-store-target="cursor"]');

if (hoverZone && cursorEl) {
    hoverZone.addEventListener('mouseenter', () => {
        cursorEl.style.opacity = '1';
        cursorEl.style.transform = 'none';
    });
    hoverZone.addEventListener('mouseleave', () => {
        cursorEl.style.opacity = '0';
    });
    hoverZone.addEventListener('mousemove', (e) => {
        const rect = hoverZone.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        cursorEl.style.transform = `translate(${x}px, ${y}px) rotate(0deg) scale(1)`;
    });
}
/* Video*/
let player;
let thumbsSwiper;
let stepSlides = [];
let stepTimes = [];
let currentActiveIndex = -1;

(function () {
    if (document.getElementById('youtube-api')) return;
    const tag = document.createElement('script');
    tag.id = 'youtube-api';
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
})();

function isInstallInView() {
    const el = document.getElementById('install');
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
}

function createYTPlayer() {
    if (player) return;

    const el = document.getElementById('install-video');
    const videoId = el.dataset.videoId;

    player = new YT.Player(el, {
        height: '100%',
        width: '100%',
        videoId: videoId,
        playerVars: { autoplay: 0, controls: 1, rel: 0, modestbranding: 1 },
        events: {
            onReady: (event) => { },
            onStateChange: (e) => {
                if (e.data === YT.PlayerState.ENDED) {
                    player.seekTo(0, true);
                    player.playVideo();
                    currentActiveIndex = 0;
                    updateActiveThumb(0);
                }
            },
        },
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const installEl = document.getElementById('install');
    if (!installEl) return;
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (typeof YT !== 'undefined' && YT.Player) {
                        createYTPlayer();
                    } else {
                        window.onYouTubeIframeAPIReady = createYTPlayer;
                    }
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0,
            rootMargin: '-150% 0px 0px 0px',
        },
    );

    observer.observe(installEl);

    thumbsSwiper = new Swiper('.install-thumbs', {
        direction: 'vertical',
        slidesPerView: 3,
        spaceBetween: 24,
        freeMode: true,
    });

    document.querySelectorAll('.install-thumbs .swiper-slide').forEach((slide, index) => {
        stepSlides.push(slide);
        stepTimes.push(parseFloat(slide.dataset.start) || 0);

        // slide.addEventListener('click', ()=>{
        //     if(!player || !player.seekTo) return;
        //     const start = parseFloat(slide.dataset.start) || 0;
        //     player.seekTo(start, true);
        //     player.playVideo();
        //     updateActiveThumb(index);
        // });
    });

    window.addEventListener('scroll', () => {
        if (!player || !player.playVideo) return;
        if (isInstallInView()) {
            player.mute();
            player.playVideo();
        } else {
            player.pauseVideo();
        }
    });

    setInterval(() => {
        if (!player || !player.getCurrentTime || !player.getDuration) return;

        const currentTime = player.getCurrentTime();
        const duration = player.getDuration();

        let activeIndex = stepTimes.length - 1;
        for (let i = 0; i < stepTimes.length; i++) {
            if (currentTime < stepTimes[i]) {
                activeIndex = i - 1 >= 0 ? i - 1 : 0;
                break;
            }
        }

        // if(activeIndex !== currentActiveIndex){
        //     currentActiveIndex = activeIndex;
        //     updateActiveThumb(activeIndex);
        // }

        // const stepStart = stepTimes[activeIndex];
        // const stepEnd = stepTimes[activeIndex + 1] || duration;
        // const stepProgress = (currentTime - stepStart) / (stepEnd - stepStart);
        // document.querySelector('.install-thumbs').style.setProperty('--progress', stepProgress);
    }, 100);
});

function updateActiveThumb(index) {
    stepSlides.forEach((slide, i) => {
        if (i === index) slide.classList.add('swiper-slide-thumb-active');
        else slide.classList.remove('swiper-slide-thumb-active');
    });
    if (thumbsSwiper) thumbsSwiper.slideTo(index);
}

/* endvideo */
document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.accordion-details');
    accordions.forEach((details) => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.accordion-details__content');
        const baseHeight =
            summary.offsetHeight +
            parseInt(getComputedStyle(details).paddingTop) +
            parseInt(getComputedStyle(details).paddingBottom);
        details.dataset.baseHeight = baseHeight;
        if (!details.hasAttribute('open')) {
            details.style.height = baseHeight + 'px';
            content.style.opacity = 0;
            content.style.pointerEvents = 'none';
        }

        summary.addEventListener('click', (e) => {
            e.preventDefault();

            if (!details.hasAttribute('open')) {
                accordions.forEach((other) => {
                    if (other !== details && other.hasAttribute('open')) {
                        const otherContent = other.querySelector('.accordion-details__content');
                        closeAccordion(other, otherContent);
                    }
                });
            }

            if (details.hasAttribute('open')) {
                closeAccordion(details, content);
            } else {
                openAccordion(details, content);
            }
        });
    });

    function openAccordion(details, content) {
        const base = parseInt(details.dataset.baseHeight);
        const contentHeight = content.scrollHeight;

        details.setAttribute('open', '');
        details.setAttribute('aria-expanded', 'true');
        details.style.height = base + 'px';

        content.style.opacity = 0;
        content.style.pointerEvents = 'none';

        requestAnimationFrame(() => {
            details.style.transition = 'height 0.25s ease';
            content.style.transition = 'opacity 0.2s ease';

            details.style.height = base + contentHeight + 'px';
            content.style.opacity = 1;
            content.style.pointerEvents = 'auto';
        });

        details.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height') {
                details.style.height = 'auto';
                details.removeEventListener('transitionend', handler);
            }
        });
    }

    function closeAccordion(details, content) {
        const base = parseInt(details.dataset.baseHeight);
        const fullHeight = details.scrollHeight;

        details.style.height = fullHeight + 'px';
        details.setAttribute('aria-expanded', 'false');

        requestAnimationFrame(() => {
            details.style.transition = 'height 0.25s ease';
            content.style.transition = 'opacity 0.2s ease';

            details.style.height = base + 'px';
            content.style.opacity = 0;
            content.style.pointerEvents = 'none';
        });

        details.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height') {
                details.removeAttribute('open');
                details.removeEventListener('transitionend', handler);
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.product-complementary .list-templates', {
        slidesPerView: 1.15,
        spaceBetween: 16,
        loop: false,

        navigation: {
            nextEl: '.product-complementary .swiper-button-next',
            prevEl: '.product-complementary .swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.product-related .list-templates', {
        slidesPerView: 1.15,
        spaceBetween: 16,
        loop: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.product-related .swiper-button-next',
            prevEl: '.product-related .swiper-button-prev',
        },

        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });
});
document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.blog-related', {
        slidesPerView: 1.15,
        spaceBetween: 16,
        loop: true,
        autoplay: true,
        loopFillGroupWithBlank: true,
        centeredSlides: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.blog-related .swiper-button-next',
            prevEl: '.blog-related .swiper-button-prev',
        },

        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });
});
const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// ===== UTM helpers =====
const STORAGE_KEY = 'utm_data';

const getStoredUTM = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;

        const { data, expiredAt } = JSON.parse(raw);
        if (expiredAt && Date.now() > expiredAt) {
            localStorage.removeItem(STORAGE_KEY);
            return null;
        }
        return data || null;
    } catch {
        return null;
    }
};

const normalizeContent = (str) => str.toLowerCase().trim().replace(/\s+/g, '_').replace(/-+/g, '_');

const getUTMContent = () => {
    const div = document.getElementById('utmContent');
    if (div) {
        const text = div.textContent.trim();
        if (text) return normalizeContent(text);
    }

    const stored = getStoredUTM();
    if (stored?.utm_content) return normalizeContent(stored.utm_content);

    return 'beae';
};

const getUTMSource = () => {
    const stored = getStoredUTM();
    return stored?.utm_source || 'beae.com';
};

const getUTMCampaign = () => {
    const stored = getStoredUTM();
    return stored?.utm_campaign || 'template';
};

// =======================

document.addEventListener('DOMContentLoaded', () => {
    const redirectTo = 'https://shopify.pxf.io/B0jzzW';

    const iframe = document.querySelector('#demo-iframe-container iframe');
    const links = document.querySelectorAll('.start-editing');

    if (!iframe || !iframe.src || !links.length) return;

    let tid = '';

    try {
        const url = new URL(iframe.src);
        const segments = url.pathname.split('/').filter(Boolean);
        tid = segments[1];
    } catch {
        console.warn('Invalid iframe src:', iframe.src);
        return;
    }
    function normalizeUTMContent(value = '') {
        return value.replace(/\+/g, ' ').trim().replace(/\s+/g, '_').replace(/-+/g, '').replace(/_+/g, '_');
    }

    links.forEach((link) => {
        const url = new URL('https://builder.beae.com/redirect');
        url.searchParams.set('utm_source', getUTMSource());
        url.searchParams.set('utm_campaign', getUTMCampaign());
        const rawContent = link.dataset.content || getUTMContent() || '';
        url.searchParams.set('utm_content', normalizeUTMContent(rawContent));
        url.searchParams.set('tid', tid);
        url.searchParams.set('to', redirectTo);
        link.href = url.toString();

        link.addEventListener('click', (e) => {
            const currentIframe = document.querySelector('#demo-iframe-container iframe');
            const iframeSrc = currentIframe?.getAttribute('src');

            if (!iframeSrc || iframeSrc.trim() === '' || iframeSrc === 'about:blank') {
                e.preventDefault();

                const alertPopup = document.getElementById('demo-alert-popup');
                if (alertPopup) {
                    alertPopup.style.display = 'flex';
                }
                return;
            }

            if (isSafari()) {
                e.preventDefault();
                const modal = document.querySelector('#safari-warning-modal');
                const overlay = document.querySelector('.bg-overlay');

                modal?.classList.add('active');
                overlay?.classList.add('active');

                const closeBtn = document.querySelector('#close-safari-modal');
                const close = () => {
                    modal?.classList.remove('active');
                    overlay?.classList.remove('active');
                };

                closeBtn?.addEventListener('click', close);
                overlay?.addEventListener('click', close);
            } else {
                link.href = buildUrl();
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.frame-item');
    const navItems = document.querySelectorAll('.navigation li');
    const navigatorEl = document.querySelector('.navigation ul');
    const featuredWrap = document.querySelector('.frame-content');
    let lastScrollY = window.scrollY;
    const offset = 100;

    function onScroll() {
        const viewportHeight = window.innerHeight;

        sections.forEach((section) => {
            const rect = section.getBoundingClientRect();
            const id = section.id;
            const navItem = document.querySelector(`.navigation li[data-item="${id}"]`);
            if (!navItem) return;

            const isActive = rect.top <= offset && rect.bottom > offset;

            if (isActive) {
                navItems.forEach((item) => {
                    item.classList.remove('active');
                    item.style.setProperty('--progress', 0);
                });

                navItem.classList.add('active');

                const scrollPassed = Math.min(Math.max(offset - rect.top, 0), rect.height);
                const progress = scrollPassed / rect.height;
                navItem.style.setProperty('--progress', progress);
            }
        });

        if (featuredWrap && navigatorEl) {
            const isDesktop = window.innerWidth >= 1024;
            if (isDesktop) {
                const featuredRect = featuredWrap.getBoundingClientRect();
                const isInFeatured = featuredRect.top <= offset && featuredRect.bottom > offset;
                const direction = window.scrollY > lastScrollY ? 'down' : 'up';

                if (isInFeatured) {
                    if (direction === 'down') navigatorEl.classList.remove('compact');
                    else navigatorEl.classList.add('compact');
                }
            }
        }

        lastScrollY = window.scrollY <= 0 ? 0 : window.scrollY;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
});
